import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const PrimaryCareIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Medical cross */}
      <path
        d="M6 2H10V6H14V10H10V14H6V10H2V6H6V2Z"
        stroke="#4169E1"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
